export type ESProperty = {
  propertyName: string;
  displayName: string;
  weight: number;
  searchEnabled: boolean;
  returnInResults: boolean;
};

export type NestedESProperty = {
  nestedFields: ESProperty[];
} & ESProperty;

export type ElasticsearchConfig = {
  codeSystem: CodeSystem;
  indexName: string;
  minimumScore: number;
  minimumNestedFieldScore: number;
  maximumNestedFieldValues: number;
  displayScore: boolean;
  properties: ESProperty[];
  nestedProperties?: NestedESProperty[];
  facetFields?: string[];
  configVersion?: number;
};

export type EsConfigMap = Partial<Record<CodeSystem, ElasticsearchConfig>>;

export const CodeSystem = {
  Adm: "adm",
  Icd10: "icd10",
  Icpc2: "icpc2",
  Nkpk: "nkpk",
  Phbu: "phbu",
  Norpat: "norpat",
  Apat: "apat",
  Nlk: "nlk",
  Provemateriale: "provemateriale",
  Anatomisk: "anatomisk",
  Snomedct: "snomedct",
  Tekstligeresultatverdier: "tekstligeresultatverdier",
  Undersokelsesmetode: "undersokelsesmetode"
};

export const ElasticsearchCodeSystems = {
  Adm: "Kodeverk i standarder",
  Icd10: "ICD-10",
  Icpc2: "ICPC-2",
  Icpc2b: "ICPC-2B",
  Nkpk: "NKPK",
  Phbu: "PHBU",
  Norpat: "NORPAT",
  Apat: "NORPAT",
  Nlk: "NLK",
  Provemateriale: "Prøvemateriale",
  Anatomisk: "Anatomisk lokalisasjon",
  Snomedct: "SNOMED CT",
  Tekstligeresultatverdier: "Tekstlige resultatverdier",
  Undersokelsesmetode: "Undersøkelsesmetode"
};

export type CodeSystem = (typeof CodeSystem)[keyof typeof CodeSystem];

export const CodeSystemUtils = {
  fromElasticsearchName: (esName: string): CodeSystem | null => {
    switch (esName) {
      case ElasticsearchCodeSystems.Icd10: {
        return CodeSystem.Icd10;
      }
      case ElasticsearchCodeSystems.Icpc2: {
        return CodeSystem.Icpc2;
      }
      case ElasticsearchCodeSystems.Icpc2b: {
        return CodeSystem.Icpc2;
      }
      case ElasticsearchCodeSystems.Nkpk: {
        return CodeSystem.Nkpk;
      }
      case ElasticsearchCodeSystems.Phbu: {
        return CodeSystem.Phbu;
      }
      case ElasticsearchCodeSystems.Norpat: {
        return CodeSystem.Norpat;
      }
      case ElasticsearchCodeSystems.Nlk: {
        return CodeSystem.Nlk;
      }
      case ElasticsearchCodeSystems.Adm: {
        return CodeSystem.Adm;
      }
      case ElasticsearchCodeSystems.Provemateriale: {
        return CodeSystem.Provemateriale;
      }
      case ElasticsearchCodeSystems.Anatomisk: {
        return CodeSystem.Anatomisk;
      }
      case ElasticsearchCodeSystems.Snomedct: {
        return CodeSystem.Snomedct;
      }
      case ElasticsearchCodeSystems.Tekstligeresultatverdier: {
        return CodeSystem.Tekstligeresultatverdier;
      }
      case ElasticsearchCodeSystems.Undersokelsesmetode: {
        return CodeSystem.Undersokelsesmetode;
      }
      default: {
        return null;
      }
    }
  }
};
